'use client'

import { createContext } from 'react'

export type ConversationSidebarContextType = {
  openSidebar: () => void
  closeSidebar: () => void
  toggleSidebar: () => void
  isSidebarOpen: boolean
}

export const ConversationSidebarContext = createContext<ConversationSidebarContextType | null>(null)

export default ConversationSidebarContext
